import { BackendPaginatedResponse } from './../../common/types/index';
import { destroy, get, post, put } from 'hooks/use-http/useHttp'
import {
  ICreateChannelPayload,
  ICreateChannelResponse,
  IChannel,
  IChannelMessagesResponse,
  ICreateChannelMessagePayload,
  IChannelMessageResponse,
  IChannelResponse,
  IChannelUser,
  ICreateChannelUsersPayload
} from './../../common/types/channels.types'

export const createChannel = async (userId: string, payload: ICreateChannelPayload) => {
  try {
    const response = (await post(`channel/${userId}`, payload, {
      dieSilent: true
    })) as ICreateChannelResponse

    return response
  } catch (err) { }
}

export const fetchChannel = async (channelId: string) => {
  try {
    const response = (await get(`channel/${channelId}`, {
      dieSilent: true
    })) as IChannel

    return response
  } catch (err) { }
}

export const getChannels = async (userId: string, pageSize = 100, page = 1, noParams?: boolean) => {
  let response
  if (noParams) {
    response = await get(`channel/user/${userId}`, {
      dieSilent: true
    })
    return response
  }
  response = await get(`channel/user/${userId}?page=${page}&pageSize=${pageSize}&dir=desc&sort=cu.created_at`, {
    dieSilent: true
  })
  return response
}

export const getPartnerChannelsById = async (partnerId: string) => {
  try {
    const response = (await get(`channel/partner/${partnerId}`, {
      dieSilent: true
    })) as IChannel[]

    return response
  } catch (err) { }
}

export const getChannelMessages = async (userId: string, channelId: string, page = 1, pageSize = 5) => {
  try {
    const response = (await get(
      `channel-message/user/${userId}/channel/${channelId}?page=${page}&pageSize=${pageSize}&dir=desc&sort=created_at`,
      {
        dieSilent: true
      }
    )) as IChannelMessagesResponse

    return response
  } catch (err) { }
}

export const createChannelMessage = async (userId: string, payload: ICreateChannelMessagePayload) => {
  try {
    const response = (await post(`channel-message/${userId}`, payload, {
      dieSilent: true
    })) as IChannelMessageResponse

    return response
  } catch (err) { }
}

export const fetchChannelUsers = async (channelId: string, page: number, pageSize: number) => {
  try {
    const response = await get(`channel/${channelId}/users?page=${page}&pageSize=${pageSize}&dir=asc&sort=updated_at&filter`)

    return response
  } catch (error) {
    
  }
  
}

export const fetchUnjoinedChannels = async (userId: string, page: number, pageSize: number) => {
  try {
    const response = await get(`channel/available/user/${userId}?page=${page}&pageSize=${pageSize}&dir=desc&sort=created_at`, {
      dieSilent: true
    })
    return response as BackendPaginatedResponse<IChannel>
  } catch(err) {
    return false
  }
}
export const getChannelUser = async (channelId: string, userId: string) => {
  try {
    const response: IChannelUser = await get(`channel/${channelId}/user/${userId}`)

    return response
  } catch (err) {
    return false
  }
}

export const deleteChannelMember = async (userId:string, channelUserId: string) => {
  const response: IChannelUser[] = await destroy(`channel/admin/${userId}/channel-user/${channelUserId}`, {
    dieSilent: true,
  })
  return response
}

export const updateChannel = async (channelId: string, userId: string, payload: Partial<IChannel>) => {
  try {
    const response: IChannel = await put(`/channel/${channelId}/user/${userId}`, payload)
    return response
  } catch (err) { }
}


export const createChannelUsers = async (channelId: string, payload: ICreateChannelUsersPayload) => {
  try {
    const response = await post(`channel/${channelId}/list`, payload)

    return response;
  } catch (err) {
    return false;
  }
}

export const createChannelUsersAllConnections = async (channelId: string, userId: string) => {
  try {
    const response = await post(`channel/${channelId}/user/${userId}/connections`, {})

    return response;
  } catch (err) {
    return false;
  }
}

export const joinChannel = async (channelId: string, userId: string) => {
  try {
    const response = await post(`channel/${channelId}/user/${userId}`, {})

    return response;
  } catch (err) {
    return false
  }
}

export const useChannelsApi = () => {

  return {
    createChannel,
    fetchChannel,
    getChannels,
    fetchUnjoinedChannels,
    getChannelMessages,
    createChannelMessage,
    getPartnerChannelsById,
    fetchChannelUsers,
    deleteChannelMember,
    updateChannel,
    getChannelUser,
    createChannelUsers,
    createChannelUsersAllConnections,
    joinChannel
  } as const
}
